<template>
  <div class="box">
    <!-- 顶部组件 -->
    <top-navigation
      :loginDialog="loginDialog"
      @loginClose="loginClose"
    ></top-navigation>
    <!-- 内容 -->
    <div class="conent">
      <div class="top">
        <el-button size="medium" plain @click="$router.go(-1)"
          >返回上一页</el-button
        >
        <span>当前位置：首页-品牌圈动态</span>
      </div>
      <div class="detail">
        <div
          class="detailBox"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="imgBox">
            <img :src="item.pictureUrl" v-if="item.pictureUrl" alt="" />
            <img src="../../assets/image/index/news.jpg" v-else alt="" />
          </div>
          <div class="detailBox2">
            <div class="detailName">
              {{ item.newsTitle }}
            </div>
            <div class="detailCon">
              {{ item.newsDescribe }}
            </div>
            <div class="detailbottom">
              <div class="detailForm">原创来自：{{ item.newsSource }}</div>
              <div class="detailRead">
                阅读：{{ item.newsRead ? item.newsRead : 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <footer-2></footer-2>
  </div>
</template>

<script>
import Footer2 from "../../components/footer/footer2.vue";
import topNavigation from "../../components/topNavigation/topNavigation.vue";
import { getPcNewsList, pcReadNewsInfo } from "@/api/public";
export default {
  components: { topNavigation, Footer2 },
  data() {
    return {
      loginDialog: false, // 登录弹窗状态
      list: "",
    };
  },
  created() {
    window.scrollTo(0, 0); // 回滚
    this.getData();
  },
  methods: {
    // 跳转新闻详情的
    goDetail(item) {
      pcReadNewsInfo({ id: item.id }).then((res) => {
        if (res.code == 200) {
          if (item.newsSourceType == 1) {
            window.open(item.newsSource, "_blank");
            this.getData()
          }
        }
      });
    },
    getData() {
      getPcNewsList({ search: "" }).then((res) => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
    // 登录状态回调
    loginClose(data) {
      this.loginDialog = data;
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .box {
    min-width: 1440px;
  }
  .thesisBox {
    width: 1156px;
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .box {
    min-width: 1680px;
  }
  .thesisBox {
    width: 1396px;
  }
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.flex-row-between {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}
.box {
  background: #f3f5f9;
}
.close {
  float: left;
  width: 36px;
  height: 36px;
  cursor: pointer;
  transform: rotate(-90deg);
}
/deep/.el-pagination {
  margin-top: 20px;
  float: right;
  .el-pager li {
    font-size: 14px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #8996a0;
    line-height: 28px;
    width: 28px;
    height: 28px;
    background: #ffffff;
    border-radius: 3px;
  }
  .btn-next {
    width: 56px;
    height: 28px;
    background: #ffffff;
    line-height: 28px;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #a4c7ff;
  color: #fff;
}

.conent {
  width: 1200px;
  margin: 0 auto;
  .top {
    margin-top: 35px;
    margin-bottom: 34px;
    span {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
      margin-left: 24px;
    }
  }
  .detail {
    .detailBox {
      width: 1201px;
      height: 204px;
      background: #ffffff;
      border-radius: 8px;
      padding: 14px 25px 14px 16px;
      box-sizing: border-box;
      display: flex;
      justify-content: start;
      margin-bottom: 12px;
      .imgBox {
        width: 280px;
        height: 176px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .detailBox2 {
        width: 888px;
        margin-left: 16px;
        .detailName {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
        }
        .detailCon {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 28px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 2行
          margin-top: 16px;
        }
        .detailbottom {
          margin-top: 40px;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 28px;
        }
      }
    }
    .detailBox:hover {
      cursor: pointer;
      box-shadow: 5px 5px 10px 5px #ccc;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/other/newDetail.vue